// Final review I2 — kirli editörde sunucu metni değişti (yeniden üretim / KK kabulü). Sessiz
// ayrışma yerine kullanıcı seçer: sunucu metnini al ya da kendi metnini koru (Kaydet etkin kalır,
// bilinçli üzerine yazma).
import { REVIEW_COPY } from "../../lib/review-copy";

interface Props {
  onTake: () => void;
  onKeep: () => void;
}

const BTN = "px-3 py-1 rounded-md text-xs font-semibold";

export function ServerChangedBand({ onTake, onKeep }: Props): JSX.Element {
  return (
    <div
      role="status"
      data-testid="review-server-changed"
      className="mb-3 rounded-md p-2.5 text-xs flex flex-wrap items-center gap-2"
      style={{
        background: "var(--color-warning-bg)",
        border: "1px solid var(--color-warning-border)",
        color: "var(--color-text)",
      }}
    >
      <span className="flex-1 min-w-0">{REVIEW_COPY.serverChangedText}</span>
      <button
        type="button"
        onClick={onTake}
        className={BTN}
        style={{ background: "var(--color-primary)", color: "var(--color-surface)" }}
      >
        {REVIEW_COPY.serverChangedTake}
      </button>
      <button
        type="button"
        onClick={onKeep}
        className={BTN}
        style={{ border: "1px solid var(--color-border)", background: "var(--color-surface)" }}
      >
        {REVIEW_COPY.serverChangedKeep}
      </button>
    </div>
  );
}
